import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import { Check } from 'lucide-react';

/**
 * Shared Process Advisor SaaS multi-select.
 * Callers may use an empty value to represent "all" when that matches the domain.
 */
export default function MetricusMultiSelect({
  label,
  options = [],
  value = [],
  onChange,
  placeholder = 'Select',
  helperText = '',
  getOptionLabel = option => option?.label || '',
  getOptionKey = option => option?.value,
  disabled = false,
  maxVisibleTags = 2,
}) {
  return (
    <div className="metricus-field metricus-multiselect-field">
      {label && <label className="metricus-field-label">{label}</label>}
      <Autocomplete
        multiple
        disableCloseOnSelect
        disabled={disabled}
        options={options}
        value={value}
        onChange={(_, next) => onChange?.(next)}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={(option, selected) => getOptionKey(option) === getOptionKey(selected)}
        limitTags={maxVisibleTags}
        classes={{
          root: 'metricus-multiselect',
          paper: 'metricus-multiselect-paper',
          listbox: 'metricus-multiselect-listbox',
          option: 'metricus-multiselect-option',
          tag: 'metricus-multiselect-tag',
        }}
        renderOption={(props, option, state) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              <Checkbox
                checked={state.selected}
                size="small"
                disableRipple
                className="metricus-option-checkbox"
                checkedIcon={<span className="metricus-check-box checked"><Check size={13}/></span>}
                icon={<span className="metricus-check-box"/>}
              />
              <span className="metricus-option-copy">
                <b>{getOptionLabel(option)}</b>
                {option?.description && <small>{option.description}</small>}
              </span>
            </li>
          );
        }}
        renderInput={params => (
          <TextField
            {...params}
            placeholder={value.length ? '' : placeholder}
            size="small"
            className="metricus-multiselect-input"
          />
        )}
      />
      {helperText && <div className="metricus-field-help">{helperText}</div>}
    </div>
  );
}
